var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfirmDialog',_vm._g(_vm._b({attrs:{"description":_vm.dialogDescription,"text":"Zaakceptować kursy do rozliczenia?","confirmText":"Tak, zaakceptuj","cancelText":"Nie"}},'ConfirmDialog',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }